import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import InternalUserService from '../services/InternalUserService';

class HelpContainer extends BaseContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.state = {
            loading: true,
        };
    }

    prepareHeaderItems() {
        return [];
    }

    prepareFooterItems() {
        return [];
    }

    render() {
        return (
            <div className='container-fluid'>
                <BreadcrumbsItem to='/help-page' className='p-link'>
                    {'Pomoc'}
                </BreadcrumbsItem>
                <React.Fragment>
                    <div className='row'>
                        <div className='col-12 help-text'>
                            Drogi użytkowniku, <br />
                            <br />W przypadku problemów technicznych z platformą dostępową możesz z kontaktować się z naszymi konsultantami
                            dostępnymi pod numerem telefonu <span className='help-phone'>XX XXX XX XX</span> lub wysłać zgłoszenie na adres
                            e-mail: <a href='mailto:pomoc@xxx.pl'>pomoc@xxx.pl</a>. <br />
                            <br />
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

HelpContainer.defaultProps = {
    viewMode: 'EDIT',
};

HelpContainer.propTypes = {
    viewMode: PropTypes.string.isRequired,
};

export default withTranslation()(HelpContainer);
